import { cls } from "@wss/cls";
import React from "react";
interface PlusShippingProps {
  hasWebPlus?: boolean;
  text: string;
}
const PlusShipping = ({
  hasWebPlus = false,
  text
}: PlusShippingProps) => {
  const content = <span className={cls("flex", "items-center", "mb-2.5", "text-[75%]", "leading-6", "text-gray-800", !hasWebPlus && "hover:text-blue-500")}>
      {text}
      <img src="//cdnimg.webstaurantstore.com/uploads/design/2017/8/plus_micro.svg" alt="Plus" aria-hidden="true" height={16} width={35} className="pl-0.5" />
    </span>;
  if (hasWebPlus) {
    return <span data-testid="plus-shipping-text">{content}</span>;
  }
  return <a href="/plus/" data-testid="plus-shipping-text" data-sentry-component="PlusShipping" data-sentry-source-file="PlusShipping.tsx">
      {content}
    </a>;
};
export default PlusShipping;